import { Field, Form, Formik } from 'formik'
import parseFullName from 'parse-full-name'
import { useRegisterMutation } from 'src/services/mainAPI'
import * as Yup from 'yup'
import { Spinner } from '../../../Spinner'

const RegisterInCartSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is required'),
    password: Yup.string().required('Password is required'),
    fullName: Yup.string().required('Full name is required')
})

export const RegisterForm = () => {
    const [register, { error }] = useRegisterMutation()

    return (
        <div>
            <h1 className="text-base font-medium text-gray-600 mb-4">
                Please create an account to continue your checkout.
            </h1>

            <div>
                <Formik
                    initialValues={{
                        email: '',
                        timezone: '',
                        password: '',
                        fullName: ''
                    }}
                    validateOnBlur
                    validationSchema={RegisterInCartSchema}
                    onSubmit={async (values) => {
                        // await signIn(values)
                        const name = parseFullName.parseFullName(values.fullName)
                        const body = {
                            email: values.email,
                            username: values.email,
                            ianaTimezone:
                                Intl.DateTimeFormat().resolvedOptions().timeZone, // iana timezone
                            password: values.password,
                            firstName: name.first || name.last,
                            lastName: name.first ? name.last : ' '
                        }

                        await register(body)
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="grid grid-cols-1 gap-4 smMd:max-w-xs">
                                <Field name="fullName">
                                    {({
                                        field, // { name, value, onChange, onBlur }
                                        meta
                                    }) => (
                                        <label className="block">
                                            <span>Full Name</span>
                                            <input
                                                autoComplete="name"
                                                type="text"
                                                className="mt-1 block w-full rounded-md py-3 border-gray-300 focus:border-yf-green focus:ring-1 focus:ring-yf-green placeholder-gray-400"
                                                {...field}
                                            />
                                            {meta.touched && meta.error && (
                                                <span className="text-red-500 text-sm">
                                                    {meta.error}
                                                </span>
                                            )}
                                        </label>
                                    )}
                                </Field>

                                <Field name="email">
                                    {({
                                        field, // { name, value, onChange, onBlur }
                                        meta
                                    }) => (
                                        <label className="block">
                                            <span>Email</span>
                                            <input
                                                autoComplete="username"
                                                type="email"
                                                className="mt-1 block w-full rounded-md py-3 border-gray-300 focus:border-yf-green focus:ring-1 focus:ring-yf-green placeholder-gray-400"
                                                {...field}
                                            />
                                            {meta.touched && meta.error && (
                                                <span className="text-red-500 text-sm">
                                                    {meta.error}
                                                </span>
                                            )}
                                        </label>
                                    )}
                                </Field>

                                <Field name="password">
                                    {({
                                        field, // { name, value, onChange, onBlur }
                                        meta
                                    }) => (
                                        <label className="block">
                                            <span>Password</span>
                                            <input
                                                autoComplete="current-password"
                                                type="password"
                                                className="mt-1 block w-full rounded-md py-3 border-gray-300 focus:border-yf-green focus:ring-1 focus:ring-yf-green placeholder-gray-400"
                                                {...field}
                                            />
                                            {meta.touched && meta.error && (
                                                <span className="text-red-500 text-sm">
                                                    {meta.error}
                                                </span>
                                            )}
                                        </label>
                                    )}
                                </Field>

                                <div className="flex flex-col text-center my-4">
                                    <button
                                        type="submit"
                                        disabled={isSubmitting}
                                        className={`mb-3 py-4 ${
                                            isSubmitting
                                                ? 'bg-gray-400 cursor-wait'
                                                : 'bg-yf-green'
                                        } text-white font-medium rounded-lg focus:outline-none focus:ring-2 ring-yf-green-400 items-center flex justify-center`}
                                    >
                                        {isSubmitting ? (
                                            <Spinner size={24} />
                                        ) : (
                                            'Create Account'
                                        )}
                                    </button>
                                </div>
                                {error && (
                                    <div className="block">
                                        <p className="text-red-500 font-medium">
                                            {error}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}
